import Button from "../../componentes/button/button";
import Multiselect from "../../componentes/multiselect/multiselect";

export const Filtros = ({ data, filters, onFiltersChange }) => {

  const updateFilter = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    onFiltersChange(prev => ({
      ...prev,
      centroCusto: [],
      contaContabil: [],
      filial: [],
      tipo: [],
      modo: [],
      usuarioCompartilhado: [],
      status: []
    }));
  };

  // Options
  const centroCustoOptions = data.centroCusto?.map(item => ({
    label: `${item.codigo} - ${item.descricao}`,
    value: item.codigo
  })) || [];

  const contaContabilOptions = data.contaContabil?.map(item => ({
    label: `${item.codigo} - ${item.descricao}`,
    value: item.codigo
  })) || [];

  const filialOptions = data.filial?.map(item => ({
    label: item,
    value: item
  })) || [];

  const tipoOptions = data.tipo?.map(item => ({
    label: item,
    value: item
  })) || [];

  const usuariosCompartilhados = data.usuariosCompartilhadores?.map(item => ({
    label: item,
    value: item
  })) || [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-8 gap-3 mt-4">

      {/* Conta */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Conta
        </label>
        <Multiselect
          value={filters.contaContabil}
          options={contaContabilOptions}
          onChange={e => updateFilter("contaContabil", e.value)}
          placeholder="Selecione Conta Contábil"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Centro de Custo */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Centro de Custo
        </label>
        <Multiselect
          value={filters.centroCusto}
          options={centroCustoOptions}
          onChange={e => updateFilter("centroCusto", e.value)}
          placeholder="Selecione Centro de Custo"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Filial */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Filial
        </label>
        <Multiselect
          value={filters.filial}
          options={filialOptions}
          onChange={e => updateFilter("filial", e.value)}
          placeholder="Selecione Filial"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Tipo */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Tipo
        </label>
        <Multiselect
          value={filters.tipo}
          options={tipoOptions}
          onChange={e => updateFilter("tipo", e.value)}
          placeholder="Selecione Tipo"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Status */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Status
        </label>
        <Multiselect
          value={filters.status}
          options={[
            { label: "Realizado", value: true },
            { label: "Pendente", value: false }
          ]}
          onChange={e => updateFilter("status", e.value)}
          placeholder="Selecione Status"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Compartilhamento */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Compartilhamento
        </label>
        <Multiselect
          value={filters.modo}
          options={[
            { label: "Somente minhas Contas", value: "MINHAS" },
            { label: "Compartilhadas por mim", value: "COMPARTILHADO_POR_MIM" },
            { label: "Compartilhadas comigo", value: "COMPARTILHADO_COMIGO" }
          ]}
          onChange={e => updateFilter("modo", e.value)}
          placeholder="Selecione Compartilhamento"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Usuário Compartilhador */}
      <div className="col-span-2">
        <label className="block text-sm font-medium mb-1">
          Filtro por Usuário Compartilhador
        </label>
        <Multiselect
          value={filters.usuarioCompartilhado}
          options={usuariosCompartilhados}
          onChange={e => updateFilter("usuarioCompartilhado", e.value)}
          placeholder="Selecione Usuário"
          display="chip"
          className="w-full text-xs border"
          filter
          showClear
        />
      </div>

      {/* Limpar */}
      <div className="flex items-end">
        {(filters.centroCusto.length ||
          filters.contaContabil.length ||
          filters.filial.length ||
          filters.tipo.length ||
          filters.modo.length ||
          filters.usuarioCompartilhado.length ||
          filters.status.length) > 0 && (
          <Button
            label="Limpar Filtros"
            iconLeft="fa fa-eraser"
            variant="gray"
            onClick={clearFilters}
          />
        )}
      </div>

    </div>
  );
};
